import React from 'react';
import { TableColumn } from 'ds/components/table';
import { HpdViolation } from 'store/state/selectors/insights/summaryTypes';
import { ViolationTableColumn, SeverityWrapper, SeverityItem } from '../styled';
import { ViolationSeverity } from 'store/state/selectors/insights/summaryTypes';
import { ColumnRendererProps } from 'components/widget/prices/prices-table/utils';

const severityToLevel: Record<ViolationSeverity, number> = {
  low: 1,
  medium: 2,
  high: 3,
};

export const SeverityIndicator: React.FC<{ severity: ViolationSeverity }> = ({ severity }) => (
  <SeverityWrapper>
    {Array(3).fill(null).map((e, id) => (
      <SeverityItem key={id} isMatched={id + 1 <= severityToLevel[severity]} />
    ))}
  </SeverityWrapper>
);

export const getSeverityColumnConfig = (): Partial<TableColumn<HpdViolation>> => ({
  sortFn: (items: HpdViolation[]) => items.sort((a, b) => severityToLevel[b.severity] - severityToLevel[a.severity]),
  width: '15%',
  gap: 0,
  renderFn: (item) => <SeverityColumn item={item} />,
});

export const SeverityColumn: React.FC<ColumnRendererProps<HpdViolation>> = ({ item }) => {
  return (
    <ViolationTableColumn>
      <SeverityIndicator severity={item.severity} />
    </ViolationTableColumn>
  );
};

